import { remCSS } from '@gimlite/common';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import React, { memo, useEffect } from 'react';
import { useStoreUIV2 } from '../../hooks/useStore.hook';
import { Text } from '../text/text.component';
import './page.component.scss';

export declare namespace PageType {
  type Props = {
    className?: string | null;
    children: React.ReactNode;
    overflow?: boolean | null;
    title?: string | null;
    subTitle?: string | null;
    padding?: boolean | null;
  };
}

export const Page = memo(
  observer(
    ({
      children,
      className,
      overflow = false,
      title,
      subTitle,
      padding = true,
    }: PageType.Props) => {
      const { MenuStore } = useStoreUIV2();

      const menu = MenuStore.menu;
      useEffect(() => {
        if (title) {
          document.title = `${title} | IEM Group`;
        }
      }, [title]);

      return (
        <div
          className={classNames('page', className)}
          style={{
            padding: padding
              ? menu.length === 0
                ? `${remCSS(12)} ${remCSS(32)} ${remCSS(32)} ${remCSS(32)}`
                : `${remCSS(24)} ${remCSS(32)} ${remCSS(24)} ${remCSS(16)}`
              : '0px',
          }}
        >
          <div className="page__header">
            {subTitle && (
              <Text variant="label" color="black_50">
                {subTitle}
              </Text>
            )}
            {title && (
              <Text variant="title-1" color="black_90">
                {title}
              </Text>
            )}
          </div>
          <div
            style={{ overflow: overflow ? 'initial' : 'auto' }}
            className="page__contain"
          >
            {children}
          </div>
        </div>
      );
    },
  ),
);
